export const timezones = [
  {
    value: '(UTC -12:00)',
    hours: 12,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -11:30)',
    hours: 11,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -11:00)',
    hours: 11,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -10:30)',
    hours: 10,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -10:00)',
    hours: 10,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -09:30)',
    hours: 9,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -09:00)',
    hours: 9,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -08:30)',
    hours: 8,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -08:00)',
    hours: 8,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -07:30)',
    hours: 7,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -07:00)',
    hours: 7,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -06:30)',
    hours: 6,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -06:00)',
    hours: 6,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -05:30)',
    hours: 5,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -05:00)',
    hours: 5,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -04:30)',
    hours: 4,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -04:00)',
    hours: 4,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -03:30)',
    hours: 3,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -03:00)',
    hours: 3,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -02:30)',
    hours: 2,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -02:00)',
    hours: 2,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -01:30)',
    hours: 1,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -01:00)',
    hours: 1,
    minutes: 0,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC -00:30)',
    hours: 0,
    minutes: 30,
    operation: 'SUBTRACT'
  },
  {
    value: '(UTC +00:00)',
    hours: 0,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +00:30)',
    hours: 0,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +01:00)',
    hours: 1,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +01:30)',
    hours: 1,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +02:00)',
    hours: 2,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +02:30)',
    hours: 2,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +03:00)',
    hours: 3,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +03:30)',
    hours: 3,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +04:00)',
    hours: 4,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +04:30)',
    hours: 4,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +05:00)',
    hours: 5,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +05:30)',
    hours: 5,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +05:45)',
    hours: 5,
    minutes: 45,
    operation: 'ADD'
  },
  {
    value: '(UTC +06:00)',
    hours: 6,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +06:30)',
    hours: 6,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +07:00)',
    hours: 7,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +07:30)',
    hours: 7,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +08:00)',
    hours: 8,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +08:30)',
    hours: 8,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +09:00)',
    hours: 9,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +09:30)',
    hours: 9,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +10:00)',
    hours: 10,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +10:30)',
    hours: 10,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +11:00)',
    hours: 11,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +11:30)',
    hours: 11,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +12:00)',
    hours: 12,
    minutes: 0,
    operation: 'ADD'
  },
  {
    value: '(UTC +12:30)',
    hours: 12,
    minutes: 30,
    operation: 'ADD'
  },
  {
    value: '(UTC +13:00)',
    hours: 13,
    minutes: 0,
    operation: 'ADD'
  }
];
